import axios, { AxiosRequestConfig, AxiosInstance } from 'axios'
import HttpClient from './HttpClient'
import HttpClientReponse from './HttpClientResponse'

export default class HttpClientAxios implements HttpClient {
  client: AxiosInstance

  constructor(options?: AxiosRequestConfig) {
    this.client = axios.create({
      responseType: 'json',
      headers: {
        'Content-Type': 'application/json'
      },
      timeout: 240000,
      maxContentLength: 524328890,
      ...options
    })
  }

  get<T>(url: string): Promise<HttpClientReponse<T>> {
    return this.client.get(url)
  }

  post<T>(url: string, data: object): Promise<HttpClientReponse<T>> {
    return this.client.post(url, data)
  }
}
